module.exports = __webpack_public_path__ + "img/img02_text_m.3446eca7.png";